import AvatarImg from "@assets/imgs/avatar.svg";
import { useAppSelector } from "@hooks/redux";
import { getTikTokImg } from "@utils/util";
import { useTranslation } from "react-i18next";

// 获取用户头像
export const useUserAvatar = () => {
  const { userInfo } = useAppSelector((state) => state.globalReducer);
  const userAvatar = userInfo.tiktokUserId ? getTikTokImg(userInfo.tiktokUserId) : AvatarImg;
  return { userAvatar };
};

export const useUserName = () => {
  const { t } = useTranslation();
  const { userInfo } = useAppSelector((state) => state.globalReducer);
  const name = [userInfo.firstName || "", userInfo.lastName || ""].join(" ").trim();
  return name ? name : t("Name");
};
